import React from 'react';
import { FaInfoCircle } from "react-icons/fa";
import { IconContext } from "react-icons";

const Summary = (props) => {
  return (
    <div className={`pda-summary-card ${props.type}`}>
      <div className="pda-summary-card-icon">
        <IconContext.Provider value={{ color: props.type === "primary" ? "#2786AF" : "#F37D7D", size:"1em" }}>
          <FaInfoCircle />
        </IconContext.Provider>
      </div>
      <div className={`pda-summary-card-title ${props.type}`}>
          <p>{props.title}</p>
      </div>
      <div className={`pda-summary-card-body ${props.type}`}>
        { props.body.map((line, index) => <li key={index}> {line.message} </li>) }
      </div>
    </div>
  )
}

export default Summary;
